import { Injectable } from '@angular/core';
import { API } from './api';

export class Eula {
    content: string;
    version: string;
}
@Injectable()
export class EulaProvider {
    constructor(private api: API) {}

    public async checkLatestEulaAccepted(): Promise<boolean> {
        try {
            const response = await this.api.get('eulas/accepted');
            return response.message.accepted;
        } catch (err) {
            throw err;
        }
    }

    public async getLatestEula(isOrganization: boolean = false): Promise<Eula> {
        try {
            const latestEula = await this.api.get(`eulas/latest${isOrganization ? '?organization=true' : ''}`);
            const eula: Eula = {
                content: latestEula.message.content,
                version: latestEula.message.version
            };
            return eula;
        } catch (err) {
            throw err;
        }
    }

    public async getEulaByToken(token: string): Promise<Eula> {
        try {
            const response = await this.api.get(`eulas/${token}/latest`);
            const eula: Eula = {
                content: response.message.content,
                version: response.message.version
            };
            return eula;
        } catch (error) {
            throw error;
        }
    }

    public async acceptEula(version: string): Promise<any> {
        try {
            await this.api.post('eulas', {
                accepted: true,
                version
            });
        } catch (err) {
            throw err;
        }
    }
}



// WEBPACK FOOTER //
// ./src/providers/eula.ts